import React, { useEffect, useState } from 'react';
import parkService from '../../../services/config/park.service';
import { Avatar, Col, Divider, Form, Input, InputNumber, Row, Select, Space, Spin, Switch } from 'antd';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import { AppstoreOutlined, LoadingOutlined } from '@ant-design/icons';

const EditFreeAddOnRuleModal = ({ form, park, free_add_on_rule_id, modal_visible, }) => {
    const [state, setState] = useState({
        loading : false,
        free_add_on_rule : null,
        
        add_on_setups : [],
        ticket_applicable_users : [],

        selected_park_applicable_ticket_type_id : null,
        selected_add_on_setup_id : null,
    })

    const fetchFreeAddOnRules = async () => {
        setState(state => ({...state, loading : true, }));
        
        const freeAddOnRuleResponse = await parkService?.getFreeAddOnRule({
            free_add_on_rule_id,
        })

        const { free_add_on_rules, } = freeAddOnRuleResponse;
        const free_add_on_rule = free_add_on_rules?.[0];

        // fetch applicable users
        const park_applicable_ticket_type = (free_add_on_rule?.add_on_setup?.park_applicable_ticket_type);
        const park_applicable_ticket_type_id = (park_applicable_ticket_type?.park_applicable_ticket_type_id);
        const fetchParkApplicableTicketTypeResponse = await parkService?.getParkApplicableTicketTypeitems({
            park_applicable_ticket_type_id,
            is_check_purchase_type : false,
        });
        const { park_applicable_ticket_users, park_applicable_add_ons, } = fetchParkApplicableTicketTypeResponse;

        const { name, add_on_setup_id, free_add_on_quantity, min_required_ticket_quantity, max_required_ticket_quantity, is_adjustable, free_add_on_rule_requires = [], } = free_add_on_rule ?? {};

        setState(state => ({
            ...state,
            loading : false,
            free_add_on_rule,
            selected_add_on_setup_id : add_on_setup_id,
            park_applicable_ticket_type : park_applicable_ticket_type,
            // selections
            ticket_applicable_users : park_applicable_ticket_users,
            add_on_setups : park_applicable_add_ons,
        }));

        // // assign to form
        if(free_add_on_rule){
            form.setFieldsValue({
                name,
                free_add_on_quantity,
                min_required_ticket_quantity,
                max_required_ticket_quantity,
                is_adjustable,
                add_on_setup_id,
                free_add_on_rule_requires : free_add_on_rule_requires?.map(x => x?.ticket_applicable_user_id),
                // free_ticket_applicable_user : free_ticket_applicable_user_id,
                // free_ticket_rule_requires : free_ticket_rule_requires?.map(x => x?.ticket_applicable_user_id),
            })
        }
    }

    useEffect(() => {
        fetchFreeAddOnRules();
    }, [free_add_on_rule_id, modal_visible])

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                <Form.Item label={'Name'} name={'name'}>
                    <Input />
                </Form.Item>
                <Form.Item label={'Ticket Type'} name={'park_applicable_ticket_type_id'}>
                    <Space>
                        <div>
                            <Avatar icon={<AppstoreOutlined />} shape='square' size='small' src={state?.park_applicable_ticket_type?.image} />
                        </div>
                        <div>
                            <span>{state?.park_applicable_ticket_type?.ticket_type?.name}</span>
                        </div>
                    </Space>
                </Form.Item>
                <Form.Item initialValue={false} label={'Is Adjustable'} name={'is_adjustable'}>
                    <Switch />
                </Form.Item>

                <Divider style={{ margin : 0, marginBottom : 12, }} />
                <div>
                    <PageHeaderComponent title={<span style={{ fontSize : 14, }}>Add On</span>} />
                    <Row gutter={[12, 12]}>
                        <Col xs={24} md={12}>
                            <Form.Item label={'Entitled Quantity'} name={'free_add_on_quantity'}>
                                <InputNumber min={0} style={{ width : '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={'Entitled Add On'} name={'add_on_setup_id'}>
                                <Select
                                // value={state?.selected_add_on_setup_id}
                                onChange={(add_on_setup_id) => setState(state => ({...state, selected_add_on_setup_id : add_on_setup_id, }))}
                                options={state?.add_on_setups?.map(x => ({ value : x?.add_on_setup_id, label : x?.add_on?.name, }))}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                <Divider style={{ margin : 0, marginBottom : 12, }} />
                <div>
                    <PageHeaderComponent title={<span style={{ fontSize : 14, }}>Condition For Ticket</span>} />
                    <Row gutter={[12, 12]}>
                        <Col xs={24} md={12}>
                            <Form.Item label={'Minimum Required Quantity'} name={'min_required_ticket_quantity'}>
                                <InputNumber min={0} style={{ width : '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item label={'Maximum Required Quantity'} name={'max_required_ticket_quantity'}>
                                <InputNumber min={0} style={{ width : '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item label={'Required Ticket'} name={'free_add_on_rule_requires'}>
                                <Select
                                mode='multiple'
                                options={state?.ticket_applicable_users?.map(x => ({ value : x?.ticket_applicable_user_id, label : x?.ticket_user_type?.name, disabled : (x?.ticket_applicable_user_id == state?.selected_free_ticket_applicable_user_id), }))}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            </Spin>
        </>
    );
}

export default EditFreeAddOnRuleModal;